import { Component, OnInit, Inject, ViewChild, Input, ViewEncapsulation, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { PositionLevelInfo } from '../model/PositionManagementInfo.model';
import { EffortPlanInfo, EffortPlanViewInfo } from '../model/effortplan.model';
import { EffortInfo } from '../model/effort.model';
import { JobInfo } from '../model/Job.model';

import { formatDate, Location } from '@angular/common';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-effort-plan',
  templateUrl: './effort-plan.component.html',
  styleUrls: ['./effort-plan.component.css']
})
export class EffortPlanComponent implements OnInit {

  baseurl: string;

  _ParamEffortGroupId: number;
  _ParamEffortGroupName: string;
  _ParamProjectSaleCode: string;
  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  ListEffortPlan: EffortPlanInfo[] = [];
  ListPosition: PositionLevelInfo[] = [];
  ListJobTitle: JobInfo[] = [];
  ListProjectSale: ProjectSaleInfo[] = [];

  ListMonth = [];

  reload: boolean = true;

  valuechange: boolean = false;

  viewOnly: boolean = false;

  validateSale: boolean = false;

  checkUploadBtn: boolean = false;

  mapJobTitle = new Map<string, string>();

  uploadEffortPlanInfoList = new Array<EffortPlanInfo>();
  

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router,
  private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, 
  private TokenService: TokenService, private cdr: ChangeDetectorRef, private location: Location, private snackBar: MatSnackBar) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamEffortGroupId = Number(this.activatedRoute.snapshot.params.EffortGroupId);
    this._ParamEffortGroupName = this.activatedRoute.snapshot.params.EffortGroupName;
    this._ParamProjectSaleCode = this.activatedRoute.snapshot.params.ProjectSaleCode;
  }

  ngOnInit(): void {

    this.LoadEffortPlan().then((data) => {
      this.ListEffortPlan = data;
      this.ListMonth = this.getMaxMonth()
    });

    //this.LoadPosition().then((data) => {
    //  this.ListPosition = data;
    //});

    this.LoadJob().then((data) => {
      this.ListJobTitle = data;

      if(this.ListJobTitle.length > 0){
        for(let j = 0; j < this.ListJobTitle.length; j++){
            this.mapJobTitle.set(this.ListJobTitle[j].JOB_CODE, this.ListJobTitle[j].JOB_NAME);
        }

      }
    });

    this.LoadProjectSale().then((data) => {
      this.ListProjectSale = data;
      if (this.ListProjectSale[0].ProjectSaleState == '1-8') this.viewOnly = true;
    });
  }

  async LoadEffortPlan() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson["EffortGroupId"] = this._ParamEffortGroupId;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "EffortGroup/GetEffortPlan", strjson, httpOptions)
        .toPromise()
    }
  }

  async SaveEffortPlan() {

    console.log(this.ListEffortPlan)

    // debugger

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let param = new EffortPlanViewInfo();

      if (this.ListEffortPlan == null || this.ListEffortPlan.length <= 0) {
        param.DeletePlanGroupId = this._ParamEffortGroupId
      } else {
        param.ListEffortPlan = this.ListEffortPlan;
      };

      let strjson = JSON.stringify(param);
      console.log("strjson param == ", strjson);

      return await this.httpClient.post<boolean>(this.baseurl + "EffortGroup/SaveEffortPlan", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadJob() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadProjectSale() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleCode'] = this._ParamProjectSaleCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise()
    }
  }

  //click func
  btnClick_reload() {

    this.validateSale = false;

    this.LoadEffortPlan().then((data) => {
      this.ListEffortPlan = data;
      this.ListMonth = this.getMaxMonth();
      this.valuechange = false;
    });
  }

  btnClick_submit() {

    this.validateSale = true;

    for (var i = 0; i < this.ListEffortPlan.length; i++) {
      let projrole = this.ListEffortPlan[i].EffortPlanProjectRole
      let role = this.ListEffortPlan[i].EffortPlanRole
      //let eff = this.ListEffortPlan[i].ListEffort
      //let emp = this.ListEffortPlan[i].EffortPlanEmpCode

      if (projrole == null || projrole == '' || projrole == ' ') return;
      if (role == null || role == '' || role == ' ') return;
      //if (eff == null || eff.length <= 0) return;
    }

    this.SaveEffortPlan().then((data) => {
      this.btnClick_reload()
    });
  }

  //misc func
  getMaxMonth() {

    // debugger
    let maxce = 0;
    let ceil = [];
    for (let i of this.ListEffortPlan) {
      //let max = Array.from(new Set(i.ListEffort.map((item: any) => item.EffortMonth)));

      //if (max.length > ceil.length) ceil = max;

      let des = i.ListEffort.sort((a, b) => {
        return a.EffortMonth < b.EffortMonth
          ? 1
          : -1
      })

      if (des[0].EffortMonth > maxce) maxce = des[0].EffortMonth;

    }

    for (let v = 1; v <= maxce; v++) ceil.push(v)

    

    return ceil;
  }

  addMonthColumn() {

    //let x = new EffortInfo();
    //x.EffortMonth = Number(this.ListMonth[this.ListMonth.length - 1]) + 1;

    let y = this.ListMonth.length > 0 ? Number(this.ListMonth[this.ListMonth.length - 1]) + 1: 1;
    this.ListMonth.push(y);

    this.valuechanged()
  }

  addRoleRow() {
    let x = new EffortPlanInfo();
    x.EffortGroupId = Number(this._ParamEffortGroupId);
    x.EffortPlanProjectRole = '';
    x.ListEffort = [];

    for (var i = 0; i < this.ListMonth.length; i++) {
      let y = new EffortInfo();
      y.EffortMonth = this.ListMonth[i];
      y.EffortManDay = null;

      x.ListEffort.push(y)
    }

    console.log(this.ListEffortPlan)
    console.log(this.ListMonth)

    this.ListEffortPlan.push(x);

    this.valuechanged()
  }

  removeMonthColumn(index) {

    if (this.viewOnly) return;

    // debugger

    for (let ind in this.ListMonth) {
      if (ind > index) this.ListMonth[ind] = this.ListMonth[ind] - 1
    }
    this.ListMonth.splice(index, 1);

    for (let i of this.ListEffortPlan) {

      //i.ListEffort.forEach((value, ind) => {
      //  if (ind > index) value.EffortMonth -= 1;
      //});

      
      let delindex = i.ListEffort.map(e => e.EffortMonth).indexOf(index + 1)

      for (let item of i.ListEffort) {
        if (item.EffortMonth > index + 1) item.EffortMonth = item.EffortMonth - 1
      }

      if(delindex > 0) i.ListEffort.splice(delindex, 1);
    }


    //for (var index in arr) {
    //  console.log(index); // prints indexes: 0, 1, 2, 3

    //  console.log(arr[index]); // prints elements: 10, 20, 30, 40
    //}

    //someArray.forEach((value, index) => {
    //  console.log(index); // 0, 1, 2
    //  console.log(value); // 9, 2, 5
    //});
    this.valuechanged()
  }

  removeRoleRow(index) {
    this.ListEffortPlan.splice(index, 1);

    this.valuechanged()
  }


  getEmployeeWorkhoursByMonth(EmployeeIndex: string, MonthSeq: string) {

    //debugger

    let res = ''

    if (this.ListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlan[EmployeeIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);

    if (rec != null && rec.length > 0) res = rec[0].EffortManDay;

    return res;
  }

  getEmployeeWorkhoursTotal(EmployeeIndex: string) {

    let res = 0

    if (this.ListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlan[EmployeeIndex].ListEffort;

    if (rec != null && rec.length > 0) res = rec.reduce((sum, current) => sum + current.EffortManDay, 0);// * 8;

    //res = this.replaceCommas(res);

    return res;
  }

  getEmployeeWorkhoursByMonthTotal(MonthSeq: string) {

    //debugger

    let rec = 0;

    for (let i of this.ListEffortPlan) {

      let x = i.ListEffort.filter(x => x.EffortMonth == Number(MonthSeq))

      if (x != null && x.length > 0) rec += x[0].EffortManDay;
      
    }

    //rec = this.replaceCommas(rec)

    //rec = rec.toFixed(2)

    return rec;
  }

  getEmployeeWorkhoursAllTotal() {

    let total = 0;

    for (let i of this.ListEffortPlan) {
      let hours = i.ListEffort.length > 0 ? i.ListEffort.reduce((sum, current) => sum + current.EffortManDay, 0) : 0;

      total += hours;// * 8;
    }

    //total = this.replaceCommas(total);

    return total;
  }



  async onFileEffortPlanChange(event: Event){
     console.log("onFileEffortPlanChange()...", event);

      let file = (event.target as HTMLInputElement).files[0];
        // if (!file) return;
         
      try {
          
        let reader = new FileReader();
        console.log("render == ", reader);
        this.uploadEffortPlanInfoList = new Array<EffortPlanInfo>();
        // let effortPlanInfoList = new Array<EffortPlanInfo>();

        reader.onload = () => {
          console.log(reader.result);

          let text = reader.result as string;
          let lines = text.split('\n').map(line => line.trim()).filter(line => line);
          
          let header =  lines[0].split(',').map(item => item.trim()); 
          console.log("header == ", header);


          if(lines.length > 0){
            let dup = 0;
            for (let i = 1; i < lines.length; i++) {
              const dataToUpload = lines[i].split(',').map(item => item.trim());
              console.log("dt ", dataToUpload);
              console.log("map = ", this.mapJobTitle.get( dataToUpload[0]));
              let jobCode = dataToUpload[0];
              if(this.mapJobTitle.has(jobCode)){
                  let effortPlanInfo = new EffortPlanInfo();
                  effortPlanInfo.EffortGroupId = Number(this._ParamEffortGroupId);
                  effortPlanInfo.EffortPlanProjectRole = this.mapJobTitle.get(dataToUpload[0]);
                  effortPlanInfo.EffortPlanRole = jobCode;
                  effortPlanInfo.ListEffort = [];

                for(let m = 1; m< dataToUpload.length; m++){
                      
                      if(dataToUpload[m]){ 
                        let effInfo = new EffortInfo();
                        effInfo.EffortMonth = m;
                        effInfo.EffortManDay = Number.parseInt(dataToUpload[m]);
                        effortPlanInfo.ListEffort.push(effInfo);
                      }       
                                  
                }

                console.log("efffortPlanInfo === " , effortPlanInfo); 
                this.uploadEffortPlanInfoList.push(effortPlanInfo);
              }else{
                console.error("Job " + jobCode +" not found");
                this.checkUploadBtn = false;
                this.uploadEffortPlanInfoList = new Array<EffortPlanInfo>();
                this.snackBar.open("Job " + jobCode +" not found", 'Close', {
                  duration: 3000,
                  panelClass: ['error-snackbar']
                });
                break;
              }


            }

          }

          if(this.uploadEffortPlanInfoList.length > 0){
              this.checkUploadBtn = true;
              // this.uploadEffortPlanInfoList = effortPlanInfoList;
 
          }
          
        }
      
        reader.readAsText(file);

      } catch (error) {
            this.checkUploadBtn = false;
            this.snackBar.open(error?.message, 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
      }
  

  }

  async onUploadEffortPlan(){
    console.log("onUploadEffortPlan()...");

    var auth_token = await this.TokenService.RefreshToken();

    if(!!auth_token){
        const httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
                })
        };

        let obj = {};
        obj["ListEffortPlan"] = this.uploadEffortPlanInfoList;
        console.log("obj === ", obj);

      let result = await this.httpClient.post<boolean>(this.baseurl + "EffortGroup/UploadEffortPlan", 
        JSON.stringify(this.uploadEffortPlanInfoList), httpOptions)
       .toPromise();
       console.log("rs = ", result);

       if(result == true){
          this.snackBar.open("Upload success", 'Close', {
              duration: 5000
            });
          this.router.navigate(['/effort-group;ProjectCode='+this._ParamProjectSaleCode]);
       }
      
       return result;
    }else{
        return null;
    }

    
  }

  ondownloadEffortPlan(){
    console.log("ondownloadEffortPlan()...", this.ListEffortPlan);

    let arr = [];
    // let listMonth = this.getMaxMonth()
    let csvContent : string = null;
    let filename = 'effortplan_'+formatDate(new Date(), "yyMMddHHmm", 'en-US')+'.csv';
    if(this.ListEffortPlan.length > 0){
        let maxLength = 0;
        let maxIndex = -1;

        for (let e = 0; e < this.ListEffortPlan.length; e++) {
          const currentLength = this.ListEffortPlan[e].ListEffort.length;
          if (currentLength > maxLength) {
            maxLength = currentLength;
            maxIndex = e;
          }
        }

      for(let e = 0; e< this.ListEffortPlan.length; e++){
          let objectjson = {};
              objectjson['EffortPlanRole'] = this.ListEffortPlan[e].EffortPlanRole;
          let i = 1;
          for(let f = this.ListEffortPlan[e].ListEffort.length - 1; f >= 0; f--){
            objectjson['M'+this.ListEffortPlan[e].ListEffort[f].EffortMonth] 
            = this.ListEffortPlan[e].ListEffort[f].EffortManDay;
            i++;
          }    
            // let effortPlanInfo = new EffortPlanInfo();
            // effortPlanInfo.EffortGroupId = this.ListEffortPlan[e].EffortGroupId;
            // effortPlanInfo.EffortPlanRole = this.ListEffortPlan[e].EffortPlanRole;
            arr.push(objectjson);

      }

      // let data = arr;

      const separator = ',';
      let allKeys = [];

      for (const obj of arr) {
        allKeys = allKeys.concat(Object.keys(obj));
      }

      const keys = Array.from(new Set(allKeys));

      // สร้าง header
      csvContent = [
        keys.join(separator), // header row
        ...arr.map(row =>
          keys.map(k => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell = cell.toString().replace(/"/g, '""'); // escape "
            return `"${cell}"`; // wrap with quotes
          }).join(separator)
        )
      ].join('\n');
      this.toDownloadFile(csvContent, filename);

    }else{

       const headers = ['EffortPlanRole']; 

       for(let i = 1; i<=36; i++){
          headers.push('M'+i);
       }
       csvContent = headers.join(',') + '\n'; 

       this.toDownloadFile(csvContent, filename);

    }

  }

  onDownloadJobTitle(){
    console.log("this.ListJobTitle === ", this.ListJobTitle);

    if(this.ListJobTitle.length > 0){
      let arr = [];
        for(let j = 0; j < this.ListJobTitle.length; j++){

            let objectjson = {};
            objectjson['JobCode'] = this.ListJobTitle[j].JOB_CODE;
            objectjson['JobName'] = this.ListJobTitle[j].JOB_NAME;
            
            arr.push(objectjson);
        }

      const separator = ',';
      let allKeys = [];

      for (const obj of arr) {
        allKeys = allKeys.concat(Object.keys(obj));
      }

      let filename = 'job_'+formatDate(new Date(), "yyMMddHHmm", 'en-US')+'.csv';
      const keys = Array.from(new Set(allKeys));

      // สร้าง header
      let csvContent = [
        keys.join(separator), // header row
        ...arr.map(row =>
          keys.map(k => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell = cell.toString().replace(/"/g, '""'); // escape "
            return `"${cell}"`; // wrap with quotes
          }).join(separator)
        )
      ].join('\n');
      this.toDownloadFile(csvContent, filename);
    }

  }

  toDownloadFile(csvContent: string, filename: string){
      
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

  }


  inputChange(EmpIndex, MonthSeq, Value) {

    // debugger

    if (this.ListEffortPlan[EmpIndex].ListEffort == null || this.ListEffortPlan[EmpIndex].ListEffort.length <= 0) {

      let lx = [];
      let x = new EffortInfo();
      x.EffortMonth = Number(MonthSeq);
      x.EffortManDay = Number(Value);

      lx.push(x)

      this.ListEffortPlan[EmpIndex].ListEffort = lx;
    } else {

      let rec = this.ListEffortPlan[EmpIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);
      if (rec == null || rec.length <= 0) {
       // let max = Array.from(new Set(this.ListEffortPlan[EmpIndex].ListEffort.map((item: any) => item.EffortMonth))).length;
        let x = new EffortInfo();
        x.EffortMonth = Number(MonthSeq);
        x.EffortManDay = (Value != '') ? Number(Value): null;
        this.ListEffortPlan[EmpIndex].ListEffort.push(x);

        this.ListEffortPlan[EmpIndex].ListEffort.sort((a, b) => {
          return a.EffortMonth >= b.EffortMonth
            ? 1
            : -1
        })

      } else {
        rec[0].EffortManDay = (Value != '') ? Number(Value) : null;
      }

    };

    console.log(this.ListEffortPlan)
    this.valuechanged()
  }

  inputProjectRoleChange(EmpIndex, Value) {
    this.ListEffortPlan[EmpIndex].EffortPlanProjectRole = Value

    this.valuechanged()
  }

  inputRoleChange(EmpIndex, Value) {
    this.ListEffortPlan[EmpIndex].EffortPlanRole = Value

    this.valuechanged()
  }

  replaceCommas(number) {
    var result = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //if (result.indexOf('.') < 0) {
    //  result += ".00";
    //}

    return result;
  }

  renderComponent() {
    this.reload = false;
    this.cdr.detectChanges();
    this.reload = true;
  }

  valuechanged() {
    this.valuechange = true;
  }

  GoBack() {
    if (this.valuechange == true) {
      confirm("Do you want to go back to previous page?") ? this.location.back() : false;
    } else {
      this.location.back()
    }
  }
}
